import {Component, CUSTOM_ELEMENTS_SCHEMA, ChangeDetectionStrategy} from '@angular/core';

import { AbstractControl, FormBuilder, Validators, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';

import { AuthService } from '../../api/services/auth.service';
import { MessageService } from '../../api/services/message.service';

import { getErrorMessage } from '../../api/utils';
import {WaButtonDirective, WaCardDirective, WaIconDirective, WaInputDirective, WaToastService} from "angular-awesome";

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    imports: [FormsModule, ReactiveFormsModule, WaCardDirective, WaInputDirective, WaButtonDirective, WaIconDirective],
    changeDetection: ChangeDetectionStrategy.Eager,
    schemas: []
})
export class LoginComponent {

  processing: boolean = false;

  loginForm = this.fb.group({
    email: ['', [
      Validators.required,
      Validators.email
    ]],
    password: ['', Validators.required]
  });

  constructor(private fb: FormBuilder,
              private authService: AuthService,
              private toastService: WaToastService,
              private router: Router) {}

  resetForm(form: UntypedFormGroup): void {
    form.reset();
    form.setErrors(null);
    form.markAsPristine();
    form.markAsUntouched();
  }

  onLogin(): void {
    if (!this.loginForm.valid)
      return;

    const loginData = {
      email: this.loginEmail!,
      password: this.loginPassword!
    };

    this.setProcessing(true);
    this.authService.guest_login(loginData).subscribe({
      next: () => {
        this.setProcessing(false);
        this.router.navigateByUrl('home');
      },
      error: err => {
        this.toastService.show(`Login attempt failed.`, { variant: 'danger' });
      }
    });
  }

  getErrorMessage(formField: AbstractControl | null): string {
    return getErrorMessage(formField);
  }

  private setProcessing(processing: boolean): void {
    this.processing = processing;
  }

  get loginEmail() { return this.loginForm.value.email || null }
  get loginPassword() { return this.loginForm.value.password || null }
}

